export const HOME = '/';
export const BASE = '/my-policy';
export const DASHBOARD = '/Dashboard';
export const LOGIN = '/Login';
export const LOGOUT = '/Logout';
export const RESETPASSWORD = '/ResetPassword';
export const REGISTERUSER = '/Register';
export const GUESTUSERLOGIN = '/GuestLogin';
export const GUESTSIGNUP = '/GuestSignup';
export const GUESTQUOTE = '/Quote/:product';
export const MESSAGES = '/Messages';
export const CLAIMS = '/Claims';
export const FNOL = '/FNOL';
export const SUBMIT_CLAIM = '/SubmitClaim';
export const SUBMIT_V2CLAIM = '/SubmitClaimV2';
export const FNOL_SUBMIT_CLAIM = '/SubmitClaimFNOL';
export const ADDCOVER = '/AddCover';
export const EMERGENCY_ASSISTANCE = '/EmergencyAssist';
export const WHATS_NEW = '/WhatsNew';
export const CALL_ME_BACK = '/CallMeBack';
export const SHOPPING_CART = '/ShoppingCart';
export const USER_ONBOARDING = '/UserOnboarding';
export const REQUEST_DOCUMENTS = '/RequestDocuments';
export const DONATE_MY_DECREASE = '/DonateDecrease';
export const REFER_A_FRIEND = '/ReferFriends';
export const CONTACT_US = '/ContactUs';
export const MY_QUOTE = '/MyQuote';
export const PERSONAL_DETAILS = '/PersonalDetails';
export const PERSONAL_DETAILS_DEETS = PERSONAL_DETAILS + '/Details';
export const PERSONAL_DETAILS_PERSONAL = PERSONAL_DETAILS_DEETS + '/Personal';
export const LIFE_PERSONAL_DETAILS = PERSONAL_DETAILS_DEETS + '/Livin';
export const PAYMENT_DETAILS = PERSONAL_DETAILS + '/PaymentDetails';
export const CHOOSE_PAYMENT_DETAILS = PERSONAL_DETAILS + '/ChoosePaymentDetails';
export const CHOOSE_PERSONAL_DETAILS = PERSONAL_DETAILS + '/ChoosePersonalDetails';
export const LIFE_PAYMENT_DETAILS = PAYMENT_DETAILS + '/Livin';
export const CHANGE_BANKING_DETAILS = PAYMENT_DETAILS + '/Livin/ChangeBankingDetails';
export const CHANGE_DEBIT_ORDER_DATE = PAYMENT_DETAILS + '/Livin/ChangeDebitOrderDate';
export const LIFE_CHANGE_DEBIT_ORDER_DATE_DEBICHECK_VALIDATE = CHANGE_DEBIT_ORDER_DATE + '/Debicheck';
export const LIFE_CHANGE_BANKING_DETAILS_DEBICHECK_VALIDATE = CHANGE_BANKING_DETAILS + '/Debicheck';
export const LIFE_SCHEDULE_SPECIAL_DEBIT = PAYMENT_DETAILS + '/Livin/ScheduleSpecialDebit';
export const PREMIUM_BREAKDOWN = '/PremiumBreakdown';
export const SA_TC_LINK = 'https://www.kingprice.co.za/terms-and-conditions/';
export const NAM_TC_LINK = 'https://www.kingprice.co.na/Home/terms-and-conditions/';
export const KING_PRICE_SA_GOOGLE_MAPS = 'http://www.google.com/maps/place/King+Price+Insurance/@-25.7893839,28.2765775,17z/data=!3m1!4b1!4m5!3m4!1s0x1e9560b853aece67:0x4f91c88040fe7f!8m2!3d-25.7893887!4d28.2787662';
export const KING_PRICE_NAM_GOOGLE_MAPS = 'https://www.google.com/maps/place/King+Price+Insurance/@-24.1592205,20.4483263,7z/data=!4m8!1m2!2m1!1sking+price+insurance+namibia!3m4!1s0x1c0b04cba54b57f3:0xc63a2f591e8b1af6!8m2!3d-22.5719118!4d17.1048878';
export const GOOGLE_MAPS_BASE_URL = 'https://www.google.com/maps/search/?api=1&query=';
export const MONTHLY_MILEAGE = '/MonthlyMileageDashboard';
export const HOME_CONTENTS = '/HomeContents';

export const PERSONAL_INSURANCE = '/PersonalInsurance';
export const LIFE_INSURANCE = '/LifeInsurance';
export const LIFE_INSURANCE_BENEFIT = LIFE_INSURANCE + '/Benefit';
export const LIFE_UPDATE_BENEFICIARIES = LIFE_INSURANCE_BENEFIT + '/UpdateBeneficiaries';
export const LIFE_ADD_BENEFICIARY = LIFE_UPDATE_BENEFICIARIES + '/AddBeneficiary';
export const LIFE_BENEFICIARY_DETAIL = LIFE_UPDATE_BENEFICIARIES + '/BeneficiaryDetail';
export const LIFE_UPDATE_POLICY_PAYOUT = LIFE_BENEFICIARY_DETAIL + '/UpdatePolicyPayout';
export const LIFE_UPDATE_BENEFICIARY_DETAILS = LIFE_BENEFICIARY_DETAIL + '/UpdateDetails';
export const LIFE_CHANGE_DEBIT_ORDER_DATE = LIFE_INSURANCE + '/ChangeDebitOrderDate';
export const LIFE_INSURANCE_CHANGE_DEBIT_ORDER_DATE_DEBICHECK_VALIDATE = LIFE_CHANGE_DEBIT_ORDER_DATE + '/Debicheck';
export const GET_LIFE_INSURANCE = '/GetLifeInsurance';
export const LIFE_INSURANCE_POLICY_DETAILS = '/LifeInsurancePolicyDetails';
export const LIFE_INSURANCE_COVER = '/LifeInsuranceCover';
export const POLICY_DETAILS = '/PolicyDetails';
export const QUOTE_DETAILS = '/QuoteDetails';
export const CAR_COVER = '/CarCover';
export const COVER_CHILLI = '/CoverChilli';
export const COVER_MOTORBIKE = '/CoverMotorbike';
export const COVER_CONTENT_BUILDING = '/CoverContentBuilding';
export const COVER_PORTABLES = '/CoverPortables';
export const COVER_WATERCRAFT = '/CoverWatercraft';
export const COVER_WARRANTY = '/Warranty';
export const COVER_PERONALACCIDENT = '/CoverPersonalAccident';
export const COVER_TRAILER = '/CoverTrailer';
export const COVER_CARAVAN = '/CoverCaravan';
export const IMAGE_PREVIEW = '/ImagePreview';
export const CLAIMS_HISTORY = '/ClaimsHistory';
export const FNOL_CLAIMS_HISTORY = '/ClaimsHistoryFNOL';
export const CLAIMS_DETAILS = '/ClaimsInfo';
export const FNOL_CLAIMS_DETAILS = '/ClaimsInfoFNOL';
export const FNOL_CLAIM_PROGRESS_MOBILE = '/ClaimProgress';
export const COVER_BLING = '/Bling'
export const WHATSAPP_LIVE_CHAT = 'https://api.whatsapp.com/send/?phone=27860505050&text=Hi&app_absent=0';
export const WHATSAPP_CLAIMS_LIVE_CHAT = 'https://api.whatsapp.com/send/?phone=27860505050&text=Hi&app_absent=0';
export const MAINTENANCESCREEN = '/MAINTENANCESCREEN';
export const SUBMIT_CLAIM_DETAILS = '/ClaimDetails';
export const SUBMIT_CLAIM_COMPLETE = '/ClaimComplete';
export const FNOL_SUBMIT_CLAIM_DETAILS = '/ClaimDetailsFNOL';
export const FNOL_SUBMIT_CLAIM_COMPLETE = '/ClaimCompleteFNOL';
export const CLAIMS_IN_THE_MEANTIME = '/ClaimInMeantime';
export const FNOL_CLAIM_DETAILS_MOBILE = '/ClaimDetailsFNOL';

//Online sales
export const ONLINE_QUOTATION = '/OnlineQuotation';
export const CAR_QUESTION = ONLINE_QUOTATION + '/CarQuestion';
export const CAR_REGISTRATION = ONLINE_QUOTATION + '/CarRegistration';
export const PORTABLE_POSSESSIONS = ONLINE_QUOTATION + '/PortablePossessions';
export const CAR_FINANCE = ONLINE_QUOTATION + '/CarFinance';
export const CAR_DETAILS = ONLINE_QUOTATION + '/CarDetails';
export const CAR_RISK = ONLINE_QUOTATION + '/CarRisk';
export const CART = ONLINE_QUOTATION + '/Cart';
export const CAR_TRACKING = ONLINE_QUOTATION + '/CarTracking';
export const CLAIM_HISTORY = ONLINE_QUOTATION + '/ClaimHistory';
export const DRIVERS_LICENCE = ONLINE_QUOTATION + '/DriversLicence';
export const INSTALL_TRACKING_DEVICE = ONLINE_QUOTATION + '/InstallTrackingDevice';
export const MARITAL_STATUS = ONLINE_QUOTATION + '/MaritalStatus';
export const SALES_ADDRESS = ONLINE_QUOTATION + '/SalesAddress';
export const QUOTATION = ONLINE_QUOTATION + '/Quotation';
export const REGULAR_DRIVER = ONLINE_QUOTATION + '/RegularUser';
export const REGULAR_DRIVER_OTHER = ONLINE_QUOTATION + '/RegularUserOther';
export const VEHICLE_LOOKUP = ONLINE_QUOTATION + '/VehicleLookup';

//Warranty
export const WARRANTY_JOURNEY_BUILDER = ONLINE_QUOTATION + '/WarrantySales';
export const GET_WARRANTY_QUOTATION = ONLINE_QUOTATION + '/GetWarrantyInsurance';

//Building and home content
export const BUILDING_AND_CONTENT_JOURNEY_BUILDER = ONLINE_QUOTATION + '/BuildingAndContentSales';
export const GET_BUILDING_QUOTATION = '/GetBuildingInsurance';
export const GET_HOME_CONTENT_QUOTATION = '/GetHomeContentInsurance';

export const ADDRESS = ONLINE_QUOTATION + '/Address';
export const BANKING_DETAILS = ONLINE_QUOTATION + '/BankingDetails';
export const CREDIT_HISTORY = ONLINE_QUOTATION + '/CreditHistory';
export const LEGAL_STUFF = ONLINE_QUOTATION + '/LegalStuff';
export const LEGAL_QUESTIONS = ONLINE_QUOTATION + '/LegalQuestions';
export const PERSONAL_INFO = ONLINE_QUOTATION + '/PersonalInfo';
export const PREMIUM = ONLINE_QUOTATION + '/Premium';
export const GET_CAR_INSURANCE = ONLINE_QUOTATION + '/GetCarInsurance';
export const GET_PORTABLE_POSSESSIONS_INSURANCE = ONLINE_QUOTATION + '/GetPortablePossessionsInsurance';
export const GET_BLING_INSURANCE = ONLINE_QUOTATION + '/GetCellphoneInsurance';
export const GET_CODE_RED_INSURANCE = ONLINE_QUOTATION + '/GetCodeRedInsurance';
export const CODE_RED_VIEW_BUILDER = ONLINE_QUOTATION + '/CodeRedSales';
export const AGREED_VALUE_SELECT = ONLINE_QUOTATION + '/AgreedValueSelect';

export const PORTABLE_POSSESSIONS_RISK = ONLINE_QUOTATION + '/PortablePossesionsRisk';
export const PORTABLE_POSSESSIONS_CLAIM_HISTORY = ONLINE_QUOTATION + '/PortablePossessionsClaimHistory';
export const ADD_REPLACEMENT_VALUE = ONLINE_QUOTATION + '/AddReplacementValue';
export const GATHER_INFO = ONLINE_QUOTATION + '/GatherInfo';
export const DESCRIBE_POSSESSION = ONLINE_QUOTATION + '/DescribePossession';
export const CELLPHONE_DETAILS = ONLINE_QUOTATION + '/CellphoneDetails';
export const REGULAR_CELLPHONE_REGISTRATION_NUMBER = ONLINE_QUOTATION + '/CellphoneRegistrationNumber';
export const COVER_OPTIONS = ONLINE_QUOTATION + '/CoverOptions';
export const CELLPHONE_CASE = ONLINE_QUOTATION + '/CellphoneCase';

export const IVERI_SUCCESS = ONLINE_QUOTATION + '/IveriSuccess';
export const IVERI_SUCCESS_CARD = '/IveriSuccessCard';
export const IVERI_FAILURE = ONLINE_QUOTATION + '/IveriFailure';

export const DOWNLOAD_THE_APP = 'https://www.kingprice.co.za/download-app';
export const SEE_AVAILABLE_AREAS = 'https://docs.aura.services/hosted-coverage-map.html';
export const OUR_REPAIRERS = 'https://www.kingprice.co.za/list-supplier/our-repairers';

//Self Inspection 
export const SELF_INSPECTION = '/SelfInspection';
export const CAPTURE_IMAGES = SELF_INSPECTION + '/CaptureImages';
export const CAPTURE_SELECT = SELF_INSPECTION + '/CaptureSelect';
export const CAPTURE_FRONT = SELF_INSPECTION + '/CaptureFront';
export const CAPTURE_LEFT = SELF_INSPECTION + '/CaptureLeft';
export const CAPTURE_RIGHT = SELF_INSPECTION + '/CaptureRight';
export const CAPTURE_BACK = SELF_INSPECTION + '/CaptureBack';
export const DASHBOARD_PHOTO = SELF_INSPECTION + '/DashboardPhoto';
export const CAR_MILEAGE = SELF_INSPECTION + '/CarMileage';
export const MILEAGE_READING = SELF_INSPECTION + '/MileageReading';
export const PREVIEW_FRONT = SELF_INSPECTION + '/PreviewFront';
export const PREVIEW_LEFT = SELF_INSPECTION + '/PreviewLeft';
export const PREVIEW_RIGHT = SELF_INSPECTION + '/PreviewRight';
export const PREVIEW_BACK = SELF_INSPECTION + '/PreviewBack';
export const CAPTURE_CAR_DETAILS = SELF_INSPECTION + '/CaptureCarDetails';
export const CAPTURE_CONDITIONS = SELF_INSPECTION + '/CaptureConditions';
export const COMPLETE = SELF_INSPECTION + '/Complete';

export const FNOL_START = '/FNOL';
export const CLAIM_HISTORY_V2 = '/HistoryOfClaims';
export const CLAIM_INFO = '/ClaimInfo';
export const CLAIM_END_PAGE = '/ClaimsEndPage';

//Styling Foundation Template 
export const STYLING_FOUNDATION = '/StylingFoundation';
export const BASE_TEMPLATE = STYLING_FOUNDATION + '/BaseTemplate';
export const BASE_START_PROCESS = STYLING_FOUNDATION + '/StartProcess';
export const BASE_STEP1 = STYLING_FOUNDATION + '/Step1';
export const BASE_STEP2 = STYLING_FOUNDATION + '/Step2';
export const BASE_STEP3 = STYLING_FOUNDATION + '/Step3';

//Claims V2

export const CLAIMSV2_CLAIM_PROGRESS_MOBILE = '/ClaimProgress';
export const CLAIMV2_DAMAGE_REPORT = '/DamageReport';
export const CLAIMSV2_TAKE_PHOTO = '/V2TakePhotos';
export const CLAIMSV2_SUBMIT_CLAIM = '/SubmitClaimV2';

//testing claims feedback
export const CLAIMSV2_FEEDBACK = '/ClaimsFeedback';

export const GLASS_REPAIRS = '/GlassRepairs';
export const GLASS_COMPLETE = '/GlassComplete';

//Payment Portal
export const PAYMENT_INITIALIZE = '/Payment/Initialize/:reference';
export const PAYMENT_SUCCESS = '/Payment/Success';
export const PAYMENT_FAILURE = '/Payment/Failure/:reference';

//Mobile Auth from app to SPP SelfInspect
export const MOBILE_AUTH = '/SelfInspect/:riskItemId';
export const MOBILE_APP_LOGIN = '/MobileLogin/:type/:identifier';